import { Component } from '@angular/core';
import { GoogleTagManagerService, MetaService } from '@prekog/pw-common';

@Component({
    selector: 'app-smarty',
    templateUrl: './smarty.component.html',
    styleUrls: ['./smarty.component.scss']
})
export class SmartyComponent {

    bookAppointmentsUrl = 'https://medicall.cc/idopontfoglalas/regenero/index';

    nameOfLink = 'IDŐPONTFOGLALÁS LINK MEGTEKINTÉSE'

    constructor(private _metaService: MetaService, private _googleTagManagerService: GoogleTagManagerService,) {
        this._metaService.settingUpOgUrl();
    }

    settingUpLinkToGoogleAnalytics() {
        this._googleTagManagerService.pushLinkIntoDataLayer(this.nameOfLink, this.bookAppointmentsUrl);
    }

}
